import { render } from "./NewsList.vue?vue&type=template&id=a4dfc1f0&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=a4dfc1f0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1364822850/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4dfc1f0"]])

export default __exports__